

export const BugVulnsIcon = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <path d="M0 0L23.605 0 23.605 23.605 0 23.605z" transform="translate(-981 -961) translate(406 961) translate(575)" />
                            <path fill={props.isActive? '#3ac0a2':'#2e2744'} fillOpacity="1" fillRule="nonzero" d="M4.986 15.736c-.046-.325-.069-.654-.068-.983v-.984H2.95v-1.967h1.967v-.983c0-.335.023-.662.068-.984H2.951V7.868h2.63c.602-1.267 1.577-2.32 2.793-3.021L7.34 3.814l1.393-1.39 1.655 1.657c.933-.195 1.896-.195 2.829 0l1.655-1.657 1.392 1.392-1.033 1.033c1.215.7 2.19 1.753 2.792 3.02h2.63v1.966h-2.036c.045.322.069.65.069.984v.983h1.967v1.967h-1.967v.984c0 .334-.024.662-.069.983h2.036v1.967h-2.63c-1.139 2.405-3.561 3.937-6.222 3.937-2.66 0-5.082-1.532-6.221-3.937H2.95v-1.967h2.035zm3.866-5.9v1.966h5.9V9.835h-5.9zm0 3.933v1.967h5.9V13.77h-5.9z" transform="translate(-981 -961) translate(406 961) translate(575)" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}